export default { 'RequestScreen.title': { en: 'Requests', fr: 'Demandes' } };
